/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'redux';
import { AxiosResponse } from 'axios';

import { http } from '../../services/axios';
import { IAuth as Auth, IChangePassword } from '../../models/auth';
import { 
    ThunkResult } from './actionResultTypes';
import { 
    Action,
    ActionType, 
    IAuthFail, 
    IAuthStart, 
    IAuthSuccess,
    IChangePasswordActive,
    IChangePasswordFail,
    IChangePasswordStart,
    IChangePasswordSuccess,
    ISelectProjectSuccess
} from '../actionTypes/authActionTypes';
import { toastError, toastSuccess } from "../../services/toasters";
import { IRequestContractChange } from '../../models/permission';


type Config = {
    headers: Record<string, string>
};
   
export const AuthStart = (username: string, password: string, navigation: () => void): ThunkResult<void> => 
    async (dispatch: Dispatch<Action>) => {
        dispatch<IAuthStart>({ type: ActionType.AUTH_START 
    });
    const config: Config = {
        headers: {
            "Content-Type": "application/json"
        }
    };
    const body = JSON.stringify({
        username,
        password
    });
    sessionStorage.removeItem('persist:root');
    try {
        const response: AxiosResponse<Auth> = await http.post(`auth/login`, body, config);
        dispatch<IAuthSuccess>({
            type: ActionType.AUTH_SUCCESS,
            payload: response.data
        });    

        const isAllProjectUser: boolean = response.data.userContractPermissions.length === 1 && 
                                          response.data.userContractPermissions[0].projectid === null
        localStorage.setItem("isAllProjectUser", JSON.stringify(isAllProjectUser));

        navigation();
    } catch (err: any) {
        dispatch<IAuthFail>({
            type: ActionType.AUTH_FAIL,
            payload: err
        });        
        console.log('Error: ', err.toString())
        toastError("نام کاربری یا کلمه عبور اشتباه می باشد");
    }
};

export const ActivateChangeUserPassword = (is_active: boolean) => {
    return (dispatch: Dispatch<Action>)=> {
        dispatch<IChangePasswordActive>({ 
            type: ActionType.CHANGEPASSWORD_ACTIVE,
            payload: is_active
        });
    }
}

export const ChangeUserPassword = (request: IChangePassword): ThunkResult<void> => async (dispatch: Dispatch<Action>) => {
    dispatch<IChangePasswordStart>({ 
        type: ActionType.CHANGEPASSWORD_START 
    });

    try {
        const response: AxiosResponse<any> = await http.put(`auth/changePassword`, request);
        dispatch<IChangePasswordSuccess>({
            type: ActionType.CHANGEPASSWORD_SUCCESS,
            payload: response.data
        });    
        toastSuccess("کلمه عبور با موفقیت تغییر یافت");

    } catch (err: any) {
        dispatch<IChangePasswordFail>({
            type: ActionType.CHANGEPASSWORD_FAIL,
            payload: err
        });        
        console.log('Error: ', err.toString())
        toastError("کلمه عبور تغییر نیافت");
    }
}

export const SetSelectedProjectPermissions = (request: IRequestContractChange) => {
    return (dispatch: Dispatch<Action>)=> {
        dispatch<ISelectProjectSuccess>({ 
            type: ActionType.SELECTPROJECT_SUCCESS,
            payload: request,
        });
    }
}

export const Refresh = () => {
    return (dispatch: Dispatch<Action>)=> {
        dispatch({
            type : ActionType.REFRESH,            
        })
    }
}

export const LogOut = () => {
    return (dispatch: Dispatch<Action>)=> {
        localStorage.removeItem('persist:root');
        sessionStorage.clear();
        dispatch({
            type : ActionType.LOGOUT,            
        })
    }
}


